import { Typography } from "@mui/material";
import Colors from "../../../../global/Colors";
import CircularGradientProgressBar from "../../../../ui library/dataVisualizations/ProgressBarCircularGradient";
import MetricInfo from "./MetricInfo";
import FullyRoundedButton from "../../../../ui library/components/buttons/FullyRoundedButton";
import KPIUnavailable from "../../../../ui library/icons/KPIUnavailable";
import { useNavigate } from "react-router-dom";
import STRINGS from "../utils/strings";

export default function CustomAccordionDetails({ accordionItemContent }) {
  const navigate = useNavigate();
  const data = accordionItemContent?.data ?? null;
  const title = data?.title ?? STRINGS.defaultTitle;
  const percentageInfo = data?.percentageScore ?? "";
  const percent = percentageInfo.value ?? 0;
  const performanceText = data?.performanceText ?? "";
  const percentageLabel = percentageInfo?.label ?? "";
  const percentagePerformanceText = percentageInfo?.performanceText ?? "";
  const kpiData = data?.cells ?? [];

  return data ? (
    <div className="flex flex-row gap-6 h-[40%] items-stretch w-full px-6 justify-evenly">
      <CircularGradientProgressBar
        progressPercent={percent}
        trackWidth={1.5}
        height={325}
        width={325}
        gradientColors={STRINGS.gradientColors}
      >
        <div className="text-center">
          <Typography className="text-black font-bold text-[6px]">
            {percentageLabel}
          </Typography>
          <div className="max-w-[60px] break-words mx-auto">
            <Typography className="font-['Robot_Slab'] font-normal text-blue-700 text-[5px] leading-tight">
              {percentagePerformanceText}
            </Typography>
          </div>
        </div>
      </CircularGradientProgressBar>
      <div className="px-2">
        <Typography className="text-3xl text-blue-700">
          <span className="font-bold text-black">
            {title}
            {", "}
          </span>
          <span className="font-['Robot_Slab']">{performanceText}</span>
        </Typography>

        <div className="flex px-0 mx-0 my-6 bg-white max-w-[100%] flex-row flex-wrap-reverse">
          {kpiData && kpiData.map((item) => <MetricInfo item={item} />)}
        </div>
      </div>
    </div>
  ) : (
    <div className="flex flex-col gap-4 px-2">
      <Typography className="text-3xl text-black">
        <span className="font-bold text-black">
          {"No KPIs Available"}
          {" - "}
        </span>
        <span className="font-['Robot_Slab']">{"No Team Assigned"}</span>
      </Typography>
      <div className="h-fit bg-sky-100 rounded-lg flex flex-col justify-center items-center gap-2 p-8">
        <KPIUnavailable />
        <Typography className="text-blue-700 font-['Robot_Slab'] text-3xl text-center">
          <span className="font-semibold">
            You’re not currently assigned to a team
          </span>
          , so your KPIs are not showing up.
        </Typography>
        <Typography className="text-black text-lg text-center">
          Please reach out to your team lead to get added to a team. Once
          you’re listed, your KPIs will be available here.
        </Typography>
        <div className="text-center w-[20%]">
          <FullyRoundedButton
            buttonWidth="w-full"
            buttonHeight="h-10"
            buttonText="View Cases"
            bgColor="bg-violet-800"
            hoverBgColor={Colors.violet[900]}
            handleOnClick={() => {
              navigate(STRINGS.navigationPaths.SEARCH);
            }}
          />
        </div>
      </div>
    </div>
  );
}
